import { LoadState } from "../../constants/enums";
import { ICourseAndBatchReport, ICourseAndBatchReportState,  } from "./type";



export const defaultCourseandBatchReport : ICourseAndBatchReport = {
    organizations_uuid: "",
    organizations_name: "",
    courses_uuid: "",
    courses_name: "",
  batch: "",
  academic_year: "",
  total_fee: "",
  fees_paid: "",
  pending_fee: "",
};

export const defaultCourseandBatchReportState: ICourseAndBatchReportState = {
    list: {
        data: [],
        loading: LoadState.NotLoaded,
        totalRecords: 0,    
        error: null,
    },
    courseandbatch: {
        data: defaultCourseandBatchReport,
        loading: LoadState.NotLoaded,
        totalRecords: 0,
        error: null,
    },
    amount: {
        totalFee: 0,
        feesPaid: 0,
        pendingFee: 0,
    },
}